import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_net_sales_reports,
  get_sales_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined, LeftOutlined, RightOutlined, DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";


const NetSalesReport = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [pagination, setPagination] = useState({});
  const componentRef = useRef(null);
  const [role, setRole] = useState("");
  const [allTotals, setAllTotals] = useState({
    subtotal: 0,
    discount: 0,
    taxamount: 0,
    delivery: 0,
    total: 0,
    netProfit: 0,
  });


  const headers = {
    name: "Net Sales",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: "0", label: "Price (Low-High)" },
          { value: "1", label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      },

      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "0", label: "Inactive" },
          { value: "1", label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "NET Sales",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
    fetchAllTotals();
  };

  const fetchData = async (tabledata, download = false) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        page: tabledata?.page || 1,
        limit: 50
      };

      if (download) {
        data.source = "Net Sales";
        data.limit = 0;
      }

      const products = await get_net_sales_reports(data);

      if (products?.status) {
        if (download) {
          return products?.data;
        } else {
          setBody(products?.data || {});
          setPagination(products?.data?.pagination || {});
          setRole(products?.data?.role);
          setLoader(false);
        }
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
    fetchAllTotals();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  const handlePageChange = (page) => {
    fetchData({ ...header, page });
  };

  const getCurrentFilters = () => {
    const filters = {};
    header.components.forEach(c => {
      if (c.name && c.value !== undefined) {
        filters[c.name] = c.value;
      }
    });
    return filters;
  };

  const fetchAllTotals = async () => {
    try {
      const filters = getCurrentFilters();

      const res = await get_net_sales_reports({
        ...filters,
        source: "Net Sales",
        limit: 0,  
      });

      if (!res?.status || !res?.data?.reports) return;

      const reports = res.data.reports;

      setAllTotals({
        subtotal: reports.reduce((a, v) => a + (v.subtotal || 0), 0),
        discount: reports.reduce((a, v) => a + (v.discount || 0), 0),
        taxamount: reports.reduce((a, v) => a + (v.taxamount || 0), 0),
        delivery: reports.reduce((a, v) => a + (v.delivery || 0), 0),
        total: reports.reduce((a, v) => a + (v.total || 0), 0),
        netProfit: reports.reduce(
          (a, v) => a + (v.grand_total_net_profit || 0),
          0
        ),
      });
    } catch (err) {
      toast.error("Failed to calculate totals");
    }
  };


  const handleFirst = () => {
    if (pagination?.currentPage > 1) {
      handlePageChange(1);
    }
  };

  const handleLast = () => {
    if (pagination?.currentPage < pagination?.totalPages) {
      handlePageChange(pagination?.totalPages);
    }
  };

  const handlePrevious = () => {
    if (pagination?.currentPage > 1) {
      handlePageChange(pagination?.currentPage - 1);
    }
  };

  const handleNext = () => {
    if (pagination?.currentPage < pagination?.totalPages) {
      handlePageChange(pagination?.currentPage + 1);
    }
  };

  const generatePageNumbers = () => {
    const currentPage = pagination?.currentPage || 1;
    const totalPages = pagination?.totalPages || 1;
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const downloadCSV = async () => {
    try {
      setLoader(true);

      const currentFilters = {};
      header.components.forEach(component => {
        if (component.name && component.value !== undefined) {
          currentFilters[component.name] = component.value;
        }
      });

      const allData = await fetchData(currentFilters, true);

      if (!allData?.reports || allData.reports.length === 0) {
        toast.error("No data available to download");
        setLoader(false);
        return;
      }

      const mainHeaders = [
        "Invoice",
        "Customer",
        "Branch",
        "Date",
        "Subtotal",
        "Discount",
        "Tax [VAT]",
        "Delivery Charge",
        "Total",
        "Net Profit"
      ];

      const detailHeaders = [
        "S.NO",
        "Description",
        "Unit",
        "QTY",
        "Ret.Price",
        "W.S Price",
        "Discount",
        "FOC",
        "VAT",
        "Total",
        "Net.Profit"
      ];

      let csvContent = [mainHeaders.join(",")];

      allData.reports.forEach((invoice, invoiceIndex) => {
        const mainRow = [
          `#INV ${invoice?.number || ""}`,
          `"${invoice?.customer?.name || ""}"`,
          `"${invoice?.branch?.name || ""}"`,
          invoice?.date ? formatDateDDMMYYYY(invoice?.date) : "",
          invoice?.subtotal?.toFixed(3) || "0.000",
          invoice?.discount?.toFixed(3) || "0.000",
          invoice?.taxamount?.toFixed(3) || "0.000",
          invoice?.delivery?.toFixed(3) || "0.000",
          invoice?.total?.toFixed(3) || "0.000",
          invoice?.grand_total_net_profit?.toFixed(3) || "0.000"
        ];
        csvContent.push(mainRow.join(","));

        csvContent.push(detailHeaders.join(","));

        invoice?.details?.forEach((detail, detailIndex) => {
          const detailRow = [
            detailIndex + 1,
            `"${detail?.name || ""}"`,
            `"${detail?.unit_name || ""}"`,
            detail?.quantity || 0,
            detail?.description?.sale_price?.toFixed(3) || "0.000",
            detail?.sale_price?.toFixed(3) || "0.000",
            `${detail?.discount_percentage || 0}% (${detail?.discount_price?.toFixed(3) || "0.000"})`,
            detail?.free || 0,
            `${detail?.tax || 0}% (${detail?.tax_amount?.toFixed(3) || "0.000"})`,
            detail?.total?.toFixed(3) || "0.000",
            detail?.total_net_profit?.toFixed(3) || "0.000"
          ];
          csvContent.push(detailRow.join(","));
        });

        if (invoiceIndex < allData.reports.length - 1) {
          csvContent.push("");
        }
      });

      const totalSubtotal = allData.reports?.reduce((acc, val) => acc + (val?.subtotal || 0), 0)?.toFixed(3) || "0.000";
      const totalDiscount = allData.reports?.reduce((acc, val) => acc + (val?.discount || 0), 0)?.toFixed(3) || "0.000";
      const totalTax = allData.reports?.reduce((acc, val) => acc + (val?.taxamount || 0), 0)?.toFixed(3) || "0.000";
      const totalDelivery = allData.reports?.reduce((acc, val) => acc + (val?.delivery || 0), 0)?.toFixed(3) || "0.000";
      const totalAmount = allData.reports?.reduce((acc, val) => acc + (val?.total || 0), 0)?.toFixed(3) || "0.000";
      const totalNetProfit = allData.reports?.reduce((acc, val) => acc + (val?.grand_total_net_profit || 0), 0)?.toFixed(3) || "0.000";
      csvContent.push("");

      csvContent.push(["GRAND TOTALS"].join(","));

      csvContent.push([
        "Subtotal",
        "Discount",
        "Tax [VAT]",
        "Delivery Charge",
        "Total",
        "Net Profit"
      ].join(","));

      csvContent.push([
        totalSubtotal,
        totalDiscount,
        totalTax,
        totalDelivery,
        totalAmount,
        totalNetProfit
      ].join(","));

      const csvString = '\uFEFF' + csvContent.join('\n');

      const blob = new Blob([csvString], {
        type: "text/csv;charset=utf-8;"
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Net_Sales_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setLoader(false);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
      setLoader(false);
    }
  };

  const downloadPDF = async () => {
    try {
      setLoader(true);

      const currentFilters = {};
      header.components.forEach(component => {
        if (component.name && component.value !== undefined) {
          currentFilters[component.name] = component.value;
        }
      });

      const allData = await fetchData(currentFilters, true);

      if (!allData?.reports || allData.reports.length === 0) {
        toast.error("No data available to download");
        setLoader(false);
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      let pdfRows = [];

      allData.reports.forEach((invoice, invoiceIndex) => {
        pdfRows.push([
          `#INV ${invoice.number}`,
          invoice.customer?.name || "",
          invoice.branch?.name || "",
          invoice.date ? formatDateDDMMYYYY(invoice.date) : "",
          invoice.subtotal?.toFixed(3),
          invoice.discount?.toFixed(3),
          invoice.taxamount?.toFixed(3),
          invoice.delivery?.toFixed(3),
          invoice.total?.toFixed(3),
          invoice.grand_total_net_profit?.toFixed(3)
        ]);

        pdfRows.push([
          "S.NO",
          "DESCRIPTION",
          "UNIT",
          "QTY",
          "RET.PRICE",
          "W.S PRICE",
          "DISC",
          "FOC",
          "VAT",
          "TOTAL",
          "NET.PROFIT"
        ]);

        invoice.details?.forEach((d, i) => {
          pdfRows.push([
            `  → ${i + 1}`,
            d.name,
            d.unit_name,
            d.quantity,
            d.description?.sale_price?.toFixed(3),
            d.sale_price?.toFixed(3),
            `${d.discount_percentage}% (${d.discount_price?.toFixed(3)})`,
            d.free,
            `${d.tax}% (${d.tax_amount?.toFixed(3)})`,
            d.total?.toFixed(3),
            d.total_net_profit?.toFixed(3)
          ]);
        });
      });

      /* 
      pdfRows.push([
        "",
        "",
        "",
        "GRAND TOTAL",
        allTotals.subtotal.toFixed(3),
        allTotals.discount.toFixed(3),
        allTotals.taxamount.toFixed(3),
        allTotals.delivery.toFixed(3),
        allTotals.total.toFixed(3),
        allTotals.netProfit.toFixed(3)
      ]); */

      autoTable(doc, {
        startY: 20,
        head: [[
          "Invoice",
          "Customer",
          "Branch",
          "Date",
          "Subtotal",
          "Discount",
          "VAT",
          "Delivery",
          "Total",
          "Net Profit"
        ]],
        body: pdfRows,
        theme: "grid",
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [222, 222, 222],
          fillColor: false,
          lineWidth: 0.2,
          fontSize: 7
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [222, 222, 222],
          lineWidth: 0.2
        },
        alternateRowStyles: {
          fillColor: false,
        },
        didParseCell: function (data) {
          const row = data.row.raw;
          if (row?.[0] === "S.NO") data.cell.styles.fontStyle = "bold";
        }
      });


      const totalsRow = [
        "Subtotal",
        allTotals.subtotal.toFixed(3),
        "Discount",
        allTotals.discount.toFixed(3),
        "Tax",
        allTotals.taxamount.toFixed(3),
        "Delivery",
        allTotals.delivery.toFixed(3),
        "Total",
        allTotals.total.toFixed(3),
        "Net Profit",
        allTotals.netProfit.toFixed(3)
      ];

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [],
        body: [totalsRow],
        theme: "grid",
        styles: {
          font: "Cairo",
          fontSize: 8,
          halign: "center",
          valign: "middle",
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          fillColor: [245, 245, 245],
        },
        columnStyles: {
          0: { cellWidth: 23 },
          1: { cellWidth: 23 },
          2: { cellWidth: 23 },
          3: { cellWidth: 23 },
          4: { cellWidth: 22 },
          5: { cellWidth: 22 },
          6: { cellWidth: 22 },
          7: { cellWidth: 22 },
          8: { cellWidth: 22 },
          9: { cellWidth: 22 },
          10: { cellWidth: 22 },
          11: { cellWidth: 22 },
        },
        didParseCell: function (data) {
          if (data.column.index % 2 === 0) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [220, 220, 220];
          }
          if (data.column.index % 2 === 1) {
            data.cell.styles.fillColor = [245, 245, 245];
          }
        }
      });


      doc.autoPrint();
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl);

      setLoader(false);

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
      setLoader(false);
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div className="mt-4">
          <div className="text-right flex gap-3 justify-end">
            <Button
              className="!bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
              type="primary"
              onClick={downloadCSV}
            >
              Download CSV
            </Button>

            <Button
              className="!bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
              type="primary"
              onClick={downloadPDF}
            >
              Download PDF
            </Button>

          </div>
        </div>

        <ScrollWrapper>

          <div className="relative">
            <div className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit pb-[96px]" ref={componentRef}>
              <table className="w-full bg-white border-collapse">
                <thead className="text-gray-500 bg-gray-100 sticky top-0 z-10">
                  <tr>
                    <th className="border p-2 text-sm font-normal text-left">
                      Invoice
                    </th>
                    <th className="border p-2 text-sm font-normal">Customer</th>
                    <th className="border p-2 text-sm font-normal">Branch</th>
                    <th className="border p-2 text-sm font-normal">Date</th>
                    <th className="border p-2 text-sm font-normal">Subtotal</th>
                    <th className="border p-2 text-sm font-normal">Discount</th>
                    <th className="border p-2 text-sm font-normal">Tax [VAT]</th>
                    <th className="border p-2 text-sm font-normal">
                      Delivery Charge
                    </th>
                    <th className="border p-2 text-sm font-normal">Total</th>
                    <th className="border p-2 text-sm font-normal text-right">
                      Net Profit
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {body?.reports?.map((value, index) => (
                    <React.Fragment key={index}>
                      <tr className="bg-white ">
                        <td className="border p-2 text-sm text-medium text-left">
                          #INV {value?.number}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.customer?.name}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.branch?.name}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.date
                            ? formatDateDDMMYYYY(value?.date)
                            : ""}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.subtotal?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.discount?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.taxamount?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.delivery?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 text-sm text-medium text-center">
                          {value?.total?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 text-sm text-medium text-right">
                          {value?.grand_total_net_profit?.toFixed?.(3)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={10} className="p-2">
                          <table className="w-full border text-gray-500 bg-gray-50">
                            <thead>
                              <tr className=" font-normal">
                                <th className="border p-1 text-xs font-normal">
                                  S.NO
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  DESCRIPTION
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  UNIT
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  QTY
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  RET.PRICE
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  W.S PRICE
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  DISC
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  FOC
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  VAT
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  TOTAL
                                </th>
                                <th className="border p-1 text-xs font-normal">
                                  NET.PROFIT
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-500">
                              {value?.details?.map((v, i) => (
                                <tr key={i} className="text-xs">
                                  <td className="border p-1 text-center">
                                    <div>{i + 1}</div>
                                  </td>
                                  <td className="border p-1 text-center">
                                    <div>
                                      <div>{v?.name}</div>
                                      <div className="text-gray-500 text-xs">
                                        #BATCH-{v?.inventory_number}
                                      </div>
                                      {v?.expiry_date && (
                                        <div className="text-gray-500 text-xs">
                                          Expiry:{" "}
                                          {formatDateDDMMYYYY(v?.expiry_date)}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.unit_name}
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.quantity}
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.description?.sale_price?.toFixed?.(3)}
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.sale_price?.toFixed?.(3)}
                                  </td>
                                  <td className="border p-1 text-center">
                                    <div>{v?.discount_percentage}%</div>
                                    <div className="text-xs text-gray-500">
                                      {v?.discount_price?.toFixed?.(3)}
                                    </div>
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.free || 0}
                                  </td>
                                  <td className="border p-1 text-center">
                                    <div>{v?.tax}%</div>
                                    <div className="text-xs text-gray-500">
                                      {v?.tax_amount?.toFixed?.(3)}
                                    </div>
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.total?.toFixed?.(3)}
                                  </td>
                                  <td className="border p-1 text-center">
                                    {v?.total_net_profit?.toFixed?.(3)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>

              </table>
              <div className="sticky bottom-0 z-30 bg-white border-t">
                <div className="bg-gray-100 border-b">
                  <table className="w-full">
                    <tbody>
                      <tr className="font-semibold bg-gray-100 text-sm">
                        <td className="border p-2 font-normal text-medium w-[40%]" colSpan={4}>
                          Total
                        </td>
                        {/* <td className="border p-2 font-normal text-medium text-center">
                          {body?.reports
                            ?.reduce((acc, val) => acc + (val?.subtotal || 0), 0)
                            ?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 font-normal text-medium text-center">
                          {body?.reports
                            ?.reduce((acc, val) => acc + (val?.discount || 0), 0)
                            ?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 font-normal text-medium text-center">
                          {body?.reports
                            ?.reduce((acc, val) => acc + (val?.taxamount || 0), 0)
                            ?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 font-normal text-medium text-center">
                          {body?.reports
                            ?.reduce((acc, val) => acc + (val?.delivery || 0), 0)
                            ?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 font-normal text-medium text-center">
                          {body?.reports
                            ?.reduce((acc, val) => acc + (val?.total || 0), 0)
                            ?.toFixed?.(3)}
                        </td>
                        <td className="border p-2 font-normal text-right text-medium w-[10%]">
                          {body?.reports
                            ?.reduce(
                              (acc, val) => acc + (val?.grand_total_net_profit || 0),
                              0
                            )
                            ?.toFixed?.(3)}
                        </td> */}
                        <td className="border p-2 text-center">
                          {allTotals.subtotal.toFixed(3)}
                        </td>
                        <td className="border p-2 text-center">
                          {allTotals.discount.toFixed(3)}
                        </td>
                        <td className="border p-2 text-center">
                          {allTotals.taxamount.toFixed(3)}
                        </td>
                        <td className="border p-2 text-center">
                          {allTotals.delivery.toFixed(3)}
                        </td>
                        <td className="border p-2 text-center">
                          {allTotals.total.toFixed(3)}
                        </td>
                        <td className="border p-2 text-right">
                          {allTotals.netProfit.toFixed(3)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {pagination?.currentPage ? (
                    <div className="p-4 bg-white">
                      <div className="flex justify-between items-center text-gray-600 text-sm font-medium w-full">
                        <div className="flex items-center">
                          <span className="pr-3">TOTAL</span>
                          <span>
                            {(() => {
                              const totalCount = Number(pagination?.totalCount) || 0;
                              const totalPages = Number(pagination?.totalPages) || 1;
                              const currentPage = Number(pagination?.currentPage) || 1;
                              const pageSize = totalPages > 0 ? Math.ceil(totalCount / totalPages) : 0;

                              const start = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
                              const end = Math.min(currentPage * pageSize, totalCount);

                              return (
                                <>
                                  {start} - {end} &nbsp;OF&nbsp; {totalCount}
                                </>
                              );
                            })()}
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <button
                            type="button"
                            className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handleFirst}
                            disabled={pagination?.currentPage === 1}
                          >
                            <DoubleLeftOutlined className="text-xs" />
                          </button>

                          <button
                            type="button"
                            className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handlePrevious}
                            disabled={pagination?.currentPage === 1}
                          >
                            <LeftOutlined className="text-xs" />
                          </button>

                          <div className="flex items-center space-x-1">
                            {generatePageNumbers().map((page, index) => (
                              <button
                                key={index}
                                className={`px-3 py-1 rounded-md min-w-[40px] ${page === pagination?.currentPage
                                  ? 'text-[#07b553] font-semibold'
                                  : page === '...'
                                    ? 'cursor-default text-gray-400'
                                    : 'hover:text-[#07b553] text-gray-600'
                                  }`}
                                onClick={() => typeof page === 'number' && handlePageChange(page)}
                                disabled={page === '...'}
                              >
                                {page}
                              </button>
                            ))}
                          </div>

                          <button
                            className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handleNext}
                            disabled={pagination?.currentPage === pagination?.totalPages}
                          >
                            <RightOutlined className="text-xs" />
                          </button>

                          <button
                            className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handleLast}
                            disabled={pagination?.currentPage === pagination?.totalPages}
                          >
                            <DoubleRightOutlined className="text-xs" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

              </div>
            </div>

          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default NetSalesReport;